export default __webpack_public_path__ + "static/media/meeting2.3b21e913.svg";